import { useEffect, useState } from 'react';
import { progressMessages, MESSAGE_ROTATION_MS } from '../constants';

export function useProgressMessage(isActive) {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (isActive) {
      const interval = setInterval(() => {
        setMessageIndex((prevIndex) => (prevIndex + 1) % progressMessages.length);
      }, MESSAGE_ROTATION_MS);
      return () => clearInterval(interval);
    } else {
      setMessageIndex(0);
    }
  }, [isActive]);

  return progressMessages[messageIndex];
}
